import React, { useEffect, useState } from "react";
import "./auth.css";
import auth_logo from "../../assets/auth_logo.png";
import login_rgt_img from "../../assets/Group 1261157977.png";
import PhoneInput from "react-phone-input-2";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { GoArrowRight } from "react-icons/go";
import "react-phone-input-2/lib/style.css";
import { sendOtpApi } from "../../services/auth";
import { Button, LoadingButton } from "../../components/header/form";
import { toastMessage } from "../../utils/toastMessage";
import { setShowAuth } from "../../store/slices/showAuthSlice";
import { useDispatch } from "react-redux";
import { decryptData, encryptData } from "../../utils/dataCipher";
import { getAuthInfo } from "../../config/AxiosInstance";
import { validateInput } from "../../schema/inputValidation";
import { auth } from "../../schema/auth/auth";
import Slider from "react-slick";
import {
  SampleNextArrow,
  SamplePrevArrow,
} from "../../components/slider/Arrow";
import { areMandatoryFieldsFilled } from "../../utils/inputValueValidation";
import { logicalicon_blue } from "../../assets";
import useButtonLoader from "hooks/useButtonLoader";

const Login = () => {
  const [searchParam] = useSearchParams();

  let info = searchParam.get("info") || {};
  let encryptedData;
  // Get the query string (encrypted data)
  if (Object.keys(info).length) {
    encryptedData = decryptData(info);
  }
  const navigate = useNavigate();
  const [submitButtonElement, setSubmitButtonElement] = useButtonLoader();
  const [phone, setPhone] = useState({
    dialCode: encryptedData?.dialCode || "",
    number: encryptedData?.number || "",
    completeMobile: encryptedData?.dialCode + encryptedData?.number || "+1",
  });

  const [error, setError] = useState({});

  const handlePhoneChange = (phone, country) => {
    const phoneWithoutCountryCode = phone.replace(country.dialCode, "");
    setPhone({
      number: phoneWithoutCountryCode,
      completeMobile: `+${country?.dialCode}${phoneWithoutCountryCode}` || "+1",
      dialCode: `${country?.dialCode}`,
    });
  };

  const validation = () => {
    const { errors, status } = validateInput(
      { number: phone?.number },
      "loginSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };
  // console.log('phone', phone)
  const handleSendOtp = async () => {
    if (validation()) {
      try {
        setSubmitButtonElement(true);
        const { data } = await sendOtpApi({
          dialCode: `${phone?.dialCode}`,
          number: phone?.number,
        });
        // console.log('data', data)
        const isSuccess = data?.success;
        toastMessage(data?.message, isSuccess ? "success" : "error", "sendOtp");
        if (isSuccess) {
          const data = {
            number: phone?.number,
            dialCode: `${phone?.dialCode}`,
          };
          navigate(`/otp?info=${encryptData(data)}`);
        }
      } catch (e) {
        console.log("Error:-", e.message);
      } finally {
        setSubmitButtonElement(false);
      }
    }
  };

  var settings = {
    dots: true,
    infinite: true,
    arrow: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow to="next" />,
    prevArrow: <SamplePrevArrow to="prev" />,
  };

  const requiredFields = ["number"];

  const formFields = {
    number: phone?.number,
  };

  // console.log(error, "Error");

  return (
    <>
      <div className="auth login">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-12">
              <div className="login_logo">
                <Link to="/">
                  <img src={logicalicon_blue} alt="" />
                </Link>
              </div>
            </div>
          </div>
          <div className="row  mbil_padding">
            <div className="col-md-6 login_wrap">
              <div className="login_content_lft">
                <h2>Login to Your Account</h2>
                <p>Glad to see you again login to your account below</p>

                <div className="form_field">
                  <label className="label">Enter your mobile number</label>
                  <div className="phone_input">
                    <PhoneInput
                      country={"ca"}
                      value={phone?.completeMobile || "+1"}
                      enableSearch={true}
                      placeholder={"Enter Mobile Number"}
                      countryCodeEditable={false}
                      onChange={handlePhoneChange}
                      onEnterKeyPress={handleSendOtp}
                      //  className="input form-control"
                    />
                  </div>

                  {/* {error?.number && !phone?.number && (
                    <span
                      className={`${
                        error?.number && !phone?.number
                          ? "invalid-feedback d-block"
                          : ""
                      }`}
                    >
                      {error?.number}
                    </span>
                  )} */}
                  <p className="code_verify">
                    We will send you a confirmation code to verify your number
                  </p>
                </div>

                {/* Next Btn */}

                <Button
                  className={`button next-button`}
                  onClick={handleSendOtp}
                  {...submitButtonElement}
                  disabled={
                    (phone?.number < 3 &&
                      phone?.number > 15 &&
                      !areMandatoryFieldsFilled(formFields, requiredFields)) ||
                    submitButtonElement?.disabled
                  }
                >
                  Next &nbsp;
                  <GoArrowRight />
                </Button>
              </div>
            </div>

            <div className="col-md-6 slider_content">
              <Slider {...settings}>
                <div className="login_img_rgt">
                  <img src={login_rgt_img} alt="" />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>

                <div className="login_img_rgt">
                  <img src={login_rgt_img} alt="" />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>

                <div className="login_img_rgt">
                  <img src={login_rgt_img} alt="" />
                  <div className="slider_para">
                    <h5>
                      Chat Beyond Limits <br /> Together
                    </h5>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
